import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
        <p>Copyright © {new Date().getFullYear()} <span>Mashirul Haque</span>. All Rights Reserved.</p>
        <p></p>
    </div>
  )
}

export default Footer